var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { ToneEntry } from './tone_entry/tone-entry';
import { Observable } from 'rxjs/Rx';
import { ToneEndedEvent, ToneRemovedEvent, ToneAddedEvent } from './tone_entry/events/index';
import { AppBus } from './../app_bus/app-bus';
import { MathUtil } from './../util/index';
import { ActivatedRoute } from '@angular/router';
export let ToneListComponent = class ToneListComponent {
    constructor(appBus, route) {
        this.appBus = appBus;
        this.route = route;
        this.audioContext = new AudioContext();
        this.entries = [];
        this.isPlaying = false;
        this.elapsed = 0;
    }
    ngOnInit() {
        this.addEntry(true);
        this.addSubscriptions();
        this.route.queryParams.subscribe(params => {
            if (params["entries"] != null) {
                try {
                    let entries = JSON.parse(params["entries"]);
                    this.entries = [];
                    this.addEntriesFromQueryParam(entries);
                }
                catch (err) {
                    console.log(params["entries"]);
                    throw new Error("Unable to parse entries");
                }
            }
            if (params["start"] == "true")
                this.startAll();
        });
    }
    addEntry(temp = false) {
        let entry = new ToneEntry();
        entry.temp = temp;
        this.entries.push(entry);
    }
    removeEntry(id) {
        this.entries = this.entries.filter(entry => entry.id != id);
    }
    startAll() {
        if (this.isPlaying)
            throw new Error("List is already playing");
        this.entries = this.entries.filter(entry => !entry.temp);
        Observable.from(this.entries)
            .flatMap(entry => entry.start(this.audioContext))
            .subscribe(Void => { }, err => {
            throw new Error(err);
        }, () => {
            this.isPlaying = true;
            this.elapsed = 0;
            this.elapsedSubscription = Observable.interval(100)
                .timeInterval()
                .subscribe(time => {
                this.elapsed += time.interval;
            }, err => {
                throw new Error(err);
            });
        });
    }
    stopAll() {
        Observable.from(this.entries)
            .flatMap(entry => entry.stop())
            .subscribe(Void => { }, err => {
            throw new Error(err);
        }, () => {
            this.elapsedSubscription.unsubscribe();
            this.isPlaying = false;
            this.addEntry(true);
            // time elapsed sometimes slightly off
            if (MathUtil.numberWithinPercentOfMod(this.elapsed, 1000, 10))
                this.elapsed = Math.round(this.elapsed / 1000) * 1000;
        });
    }
    entriesValid() {
        return Observable.from(this.entries)
            .filter(entry => !entry.temp)
            .defaultIfEmpty(null)
            .every(entry => {
            if (entry == null)
                return false;
            return entry.validate();
        });
    }
    addSubscriptions() {
        this.appBus.addSubscription(ToneEndedEvent.name, o => o
            .subscribe(event => {
            if (this.entries.every(entry => entry.ended))
                this.stopAll();
        }, err => {
            throw new Error(err);
        }));
        this.appBus.addSubscription(ToneRemovedEvent.name, o => o
            .subscribe(event => this.removeEntry(event.toneEntry.id), err => {
            throw new Error(err);
        }));
        this.appBus.addSubscription(ToneAddedEvent.name, o => o
            .subscribe(event => this.addEntry(true), err => {
            throw new Error(err);
        }));
    }
    addEntriesFromQueryParam(entries) {
        Observable.from(entries)
            .map(input => {
            let entry = new ToneEntry();
            for (let key in input) {
                entry.frequency = input["frequency"];
            }
            return entry;
        })
            .subscribe(entry => this.entries.push(entry));
    }
};
ToneListComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'tone-list-component',
        styleUrls: ['tone-list.css'],
        templateUrl: 'tone-list.html'
    }), 
    __metadata('design:paramtypes', [AppBus, ActivatedRoute])
], ToneListComponent);
//# sourceMappingURL=tone-list.component.js.map